<template>
  <div class="studyDtl">
    <div class="shichang">
      <div class="duration">
        <div class="classSty">
          <div class="text">总学习时长</div>
          <div class="minute">
            <span>{{ particulas.total_study_time }}</span> 分钟
          </div>
        </div>
        <div class="classSty">
          <div class="text">总娱乐时长</div>
          <div class="minute">
            <span>{{ particulas.total_time }}</span> 分钟
          </div>
        </div>
        <div class="tipSty">
          <!-- <div v-for="item in particulas?.ui_detail">
            {{item.}}
          </div> -->
          <div>
            社交时长<span class="fontSty">{{ particulas?.social || 0 }}</span
            >分钟
          </div>
          <div>
            装扮时长<span class="fontSty">{{ particulas?.dress || 0 }}</span
            >分钟
          </div>
          <div class="margin-top-24">
            宠物庄园<span class="fontSty">{{ particulas?.pet || 0 }}</span
            >分钟
          </div>
        </div>
      </div>
    </div>
    <div>本周详情</div>
    <div id="myChart"></div>
  </div>
</template>

<script>
import * as echarts from "echarts";

export default {
  props: {
    particulas: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {};
  },
  components: {},
  created() {},
  mounted() {
    console.log(this.particulas,'999----')
  },
  watch: {
    particulas(newValue) {
      console.log(newValue);
      this.myChartInit();
    },
  },
  methods: {
    myChartInit() {
      let myChart = echarts.init(document.getElementById("myChart"));
      let weekList = ["周一", "周二", "周三", "周四", "周五", "周六", "周日"]; // 周次
      let timeList = []; // 娱乐时长
      let study_time = []; // 学习市场
      this.particulas.daily_detail.forEach((element) => {
        // weekList.push(element.week_name)
        timeList.push(element.time);
        study_time.push(element.ddj_study_time);
      });
      console.log(timeList);
      // 绘制图表
      myChart.setOption({
        title: {
          // text: "本周详情",
          // top:-10
        },
        // tooltip: {
        //   trigger: "axis", // 坐标轴触发，主要用于柱状图、折线图等
        //   axisPointer: {
        //     type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
        //   },
        // },
        xAxis: {
          type: "category",
          axisTick: {
            //控制刻度横线的显示
            show: false,
          },
          data: weekList,
        },
        yAxis: [
          {
            name: "时长（分钟）",
            type: "value",
            show: true,
            axisLine: {
              show: false,
            },
            axisTick: {
              //控制刻度横线的显示
              show: false,
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: "dashed",
              },
            },
          },
        ],
        legend: {
          data: ["娱乐", "学习"],
          textStyle: {
            color: "4B4F54",
          },
          left: "center",
          itemWidth: 5,
          itemHeight: 5,
          // itemGap: 35
        },

        series: [
          {
            name: "娱乐",
            itemStyle: {
              normal: {
                color: "#58ABF6",
              },
            },
            type: "bar",
            data: timeList,
            label: {
              show: true,
              position: "top", //在上方显示
              textStyle: {
                //数值样式
                fontSize: "12px",
                color: "#58ABF6",
              },
            },
          },
          {
            name: "学习",
            itemStyle: {
              normal: {
                color: "#96CB22",
              },
            },
            type: "bar",
            data: study_time,
            label: {
              show: true,
              position: "top", //在上方显示
              textStyle: {
                //数值样式
                fontSize: "12px",
                color: "#96CB22",
              },
            },
          },
        ],
      });
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },
  },
};
</script>
<style scoped lang="less">
.margin-top-24 {
  margin-top: 24px;
}
.studyDtl {
  font-size: 32px;
}
.duration {
  background: #f6f9fd;
  padding: 40px 24px 24px 24px;
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  .classSty {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 32px;
    .minute {
      color: #323232;
      font-size: 24px;
      margin-top: 10px;
      span {
        font-size: 56px;
        color: #58abf6;
        font-weight: bold;
      }
    }
  }
  .tipSty {
    width: 100%;
    border: 2px solid #d3d8e8;
    border-radius: 16px;
    position: relative;
    font-size: 28px;
    padding: 24px 56px;
    color: #323232;
    margin-top: 22px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .fontSty {
      font-size: 40px;
      color: #4b4f54;
      font-weight: bold;
      line-height: 56px;
    }
  }
  .tipSty::after {
    position: absolute;
    content: " ";
    width: 20px;
    height: 20px;
    transform: rotate(45deg);
    background-color: #f6f9fd;
    border-top: 2px solid #d3d8e8;
    border-left: 2px solid #d3d8e8;
    right: 150px;
    top: -12px;
  }
}
#myChart {
  min-height: 620px;
  height: 100%;
}
.shichang {
  margin-bottom: 60px;
}
</style>
